import { Dialog, DialogHeaderProps } from '@pelckmans/business-components/components/dialog';
import TutorialEndAdornment from '../../_components/TutorialEndAdornment';

type MaterialModalHeaderProps = {
  title: string;
  description: string;
  contentType: React.ReactNode;
  tutorialId?: string;
} & Pick<DialogHeaderProps, 'endAdornment'>;

export default function MaterialModalHeader({
  title,
  description,
  contentType,
  tutorialId,
  endAdornment,
}: MaterialModalHeaderProps) {
  return (
    <Dialog.Header
      title={title}
      endAdornment={endAdornment ?? (tutorialId && <TutorialEndAdornment tutorialId={tutorialId} />)}
      data-testid="dialog-header"
    >
      <div className="dialog-subtitle">
        <span className="dialog-subtitle__part">
          <i className="bc-icon bc-icon-bookmark" role="img" />
          <span>{description}</span>
        </span>
        <span className="dialog-subtitle__part">{contentType}</span>
      </div>
    </Dialog.Header>
  );
}
